/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Category } from '../models/Category';
import type { CategoryAdd } from '../models/CategoryAdd';
import type { CategoryList } from '../models/CategoryList';
import type { Product } from '../models/Product';
import type { ProductAdd } from '../models/ProductAdd';
import type { ProductList } from '../models/ProductList';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ProductsService {
    /**
     * Get categories
     * Get categories
     * @returns CategoryList OK
     * @throws ApiError
     */
    public static categoriesList(): CancelablePromise<CategoryList> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/categories',
        });
    }
    /**
     * Add categories
     * Add category
     * @param requestBody Add category
     * @returns Category OK
     * @throws ApiError
     */
    public static categoryAdd(
        requestBody?: CategoryAdd,
    ): CancelablePromise<Category> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/categories',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get category by product id
     * @param id Category_id
     * @returns Category OK
     * @throws ApiError
     */
    public static getCategory(
        id: number,
    ): CancelablePromise<Category> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/categories/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Update category
     * update category by id
     * @param id product_id
     * @param requestBody Update category data
     * @returns Category OK
     * @throws ApiError
     */
    public static updateCategory(
        id: number,
        requestBody?: CategoryAdd,
    ): CancelablePromise<Category> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/categories/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Products list
     * Show list of products in json format
     * @returns ProductList OK
     * @throws ApiError
     */
    public static productsList(): CancelablePromise<ProductList> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/products',
        });
    }
    /**
     * Add product
     * Add product in list
     * @param requestBody Add product
     * @returns Product OK
     * @throws ApiError
     */
    public static productsAdd(
        requestBody?: ProductAdd,
    ): CancelablePromise<Product> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/products',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get product by product id
     * @param id Product_id
     * @returns Product OK
     * @throws ApiError
     */
    public static getProduct(
        id: number,
    ): CancelablePromise<Product> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/products/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Update products
     * update products by id
     * @param id product_id
     * @param requestBody Update products data
     * @returns Product OK
     * @throws ApiError
     */
    public static updateProduct(
        id: number,
        requestBody?: ProductAdd,
    ): CancelablePromise<Product> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/products/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
